import { ShopData, ShopProduct } from '@openticket/lib-shop';

export function getGlobalProduct(
    data: ShopData,
    className: string,
    eventId?: string
): ShopProduct | undefined {
    for (const product of data.global_products) {
        if (product.item.class === className) {
            return product;
        }
    }

    if (eventId) {
        for (const product of data.events_map[eventId].global_products) {
            if (product.item.class === className) {
                return product;
            }
        }
    } else {
        for (const event of data.events) {
            for (const product of event.global_products) {
                if (product.item.class === className) {
                    return product;
                }
            }
        }
    }
}

export function getCustomerSessionId(fallback: string): string {
    if (
        !('rudderanalytics' in window) ||
        typeof window.rudderanalytics !== 'object'
    ) {
        return fallback;
    }

    const rudderAnalytics = window.rudderanalytics;
    if (
        !rudderAnalytics ||
        !('getAnonymousId' in rudderAnalytics) ||
        typeof rudderAnalytics.getAnonymousId !== 'function'
    ) {
        return fallback;
    }

    // DD-4EA2 Send rudderstack id as session id, fall back to an in memory session id
    try {
        const eaid = rudderAnalytics.getAnonymousId();
        if (eaid) {
            return eaid;
        }
    } catch (e) {
        /* No-op */
    }

    return fallback;
}
